module.exports = __webpack_public_path__ + "img/audioring.07f1a53.webp";